import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { LoginErrorType } from "../../providers/LoginService"

const PASSWORD_ERROR_ID = "password-error-id"

export const LoginWithPasswordErrorHelperText = ({ error }: { error: string }) => {
  const { i18n } = useTranslations()

  const errorMessageI18nKeys: Record<LoginErrorType, string> = {
    invalid_client: "Login:NotAllowedIp",
    invalid_grant: "Login:InvalidUsernameOrPassword",
    disabled_client: "Login:DisabledUser",
    invalid_role: "Login:NoRole",
  }

  return <div id={PASSWORD_ERROR_ID}>{i18n(errorMessageI18nKeys[error])}</div>
}
